import { render, staticRenderFns } from "./UiIcon.vue?vue&type=template&id=d1236a0c"
import script from "./UiIcon.vue?vue&type=script&lang=js"
export * from "./UiIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1236a0c')) {
      api.createRecord('d1236a0c', component.options)
    } else {
      api.reload('d1236a0c', component.options)
    }
    module.hot.accept("./UiIcon.vue?vue&type=template&id=d1236a0c", function () {
      api.rerender('d1236a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui-icon/UiIcon.vue"
export default component.exports